<template>
    <div>
        <div>
            <img class="zgmh" src="~@public/img/hotApply/fzzx.jpg">
        </div>
        <p class="title">长按图片，识别湖北省反诈中心微信公众号</p>
    </div>
</template>

<script>
    export default {
        name: "AntiFraud"
    }
</script>

<style scoped>
    .zgmh {
        width: 75%;
        margin: 4.0rem 1.0rem 1.0rem 1.2rem
    }
    .title{
        font-size: 0.5rem;
        text-align: center;
        color:black;
    }
</style>
